import mobileFloorStoreLogo from "@/assets/the-mobile-floor-store-logo.webp";
import hugoSilva from "@/assets/hugo-silva.webp";
import {
  Attribution,
  CountUp,
  QuoteCard,
  useInViewRef,
} from "@/components/sections/testimonial/shared";

export function Step1Testimonial() {
  const { ref, inView } = useInViewRef<HTMLElement>();

  return (
    <section ref={ref} className="flex flex-col">
      <div className="flex items-center gap-6">
        <h2 className="text-4xl font-bold tracking-tight text-foreground">
          We increased their
          <br />
          site&rsquo;s monthly leads
        </h2>
        <span className="text-gradient-cycle text-6xl font-bold sm:text-7xl lg:text-8xl tabular-nums">
          <CountUp target={5} start={inView} suffix="x" />
        </span>
      </div>

      <QuoteCard>
        The new site looks far more professional, but more importantly we
        started getting{" "}
        <span className="text-gradient-cycle font-bold">more quote requests</span>{" "}
        from the right homeowners.
      </QuoteCard>

      <Attribution
        avatarSrc={hugoSilva}
        avatarAlt="Hugo Silva"
        name="Hugo Silva"
        role="Owner, The Mobile Floor Store"
        logoSrc={mobileFloorStoreLogo}
        logoAlt="The Mobile Floor Store logo"
        logoClassName="h-12 shrink-0"
        nameNoWrap
      />
    </section>
  );
}
